import { type FC } from 'react';
import { format } from 'date-fns';
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

interface ApplicationDetailsTrendProps {
  className: string;
  hasEvaluationTrendData: boolean;
  evaluationTrendData: Array<{
    generatedAt: string;
    score: number;
  }>;
}

const ApplicationDetailsTrend: FC<ApplicationDetailsTrendProps> = ({
  className,
  hasEvaluationTrendData,
  evaluationTrendData,
}) => (
  <div className={className}>
    <h2 className="text-sm font-medium">Evaluation Trend</h2>
    <div className="w-full h-[250px] max-h-[50vh] min-h-[150px] pr-5">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={evaluationTrendData}>
          <CartesianGrid
            strokeDasharray="1 1"
            horizontal={true}
            vertical={false}
            stroke="#e5e7eb"
          />
          <XAxis tick={false} dataKey="generatedAt" />
          <YAxis
            width={30}
            domain={[0, 100]}
            ticks={[0, 20, 40, 60, 80, 100]}
            tickCount={6}
          />
          {hasEvaluationTrendData ? (
            <Tooltip
              labelFormatter={(label) => {
                return format(new Date(label), 'yyyy-MM-dd HH:mm');
              }}
            />
          ) : null}
          <Bar
            barSize={10}
            radius={[10, 10, 0, 0]}
            type="monotone"
            dataKey="score"
            stroke="#007ac3"
            fill="#007ac3"
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  </div>
);

export default ApplicationDetailsTrend;
